import React, { useCallback, useMemo } from "react"
import { useStageContext } from "@/components/Menu/Mobile/Stages/index"
import CommonIcon from "@/components/common/Icon/Icon"
import Text from "@/components/common/Text"
import styled from "styled-components"
import { ICONS } from "@/constants"
import { getLinkData } from "@/components/common/Links/utils"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Child from "@/components/Menu/Shared/Child"
import Header from "@/components/Menu/Shared/Header"
import { useRouter } from "next/router"

const Icon = styled(CommonIcon)`
	--local-padding: ${getCssSizeValue(6, BREAKPOINTS.MOBILE)};
	width: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	padding: var(--local-padding);
	aspect-ratio: 1;
	transform: translateX(calc(var(--local-padding) * -1));

	svg {
		rotate: -180deg;
	}
`
const Top = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: var(--paddingX);
	padding-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	border-bottom: solid 1px ${({ theme }) => theme.colors.chineseViolet};
`
const Children = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	row-gap: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	width: 100%;
	height: 100%;
	overflow-y: auto;
`

const Stage1 = () => {
	const { item, setStage, setItem } = useStageContext()
	const onBackClick = useCallback(() => {
		setStage(0)
		setItem({})
	}, [setStage, setItem])
	const children = item?.children || []
	const { text, url } = useMemo(() => {
		const { text, url } = getLinkData(item.universalLink)
		return {
			text,
			url,
		}
	}, [item])

	const { locale } = useRouter()
	const backText = locale === "pl" ? "POWRÓT DO MENU" : locale === "en" ? "BACK TO MENU" : "ZURÜCK ZUM MENÜ"

	return (
		<>
			<Top>
				<Icon name={ICONS.CHEVRON} onClick={onBackClick} color="periwinkle" />
				<Text color="antiflashWhite" className="typo-borna typo-borna-42">
					{backText.toUpperCase()}
				</Text>
			</Top>
			<Children className="px-main" data-scroll-ignore-lock>
				<Header isLink url={url} square={false} color="periwinkle">
					{text}
				</Header>
				{children.map((item, index) => (
					<Child key={item?.id || index} data={item} color="antiflashWhite" square={false} />
				))}
			</Children>
		</>
	)
}

export default Stage1
